import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=1d5036c8&scoped=true&"
import script from "./Confirm.vue?vue&type=script&lang=js&"
export * from "./Confirm.vue?vue&type=script&lang=js&"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=1d5036c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5036c8",
  null
  
)

export default component.exports